const moduleImages = [	
	'modules/tasks/task-intro/printer.svg',
	'modules/tasks/task-intro/secretary-calling.svg',
	'modules/tasks/task-intro/shelf.svg'
];

export {
	moduleImages
};